import { useTelemetry } from '@ctw/shared/context/telemetry/telemetry-boundary';
import { twx } from '@ctw/shared/utils/tailwind';
import {
  faThumbsDown as faThumbsDownRegular,
  faThumbsUp as faThumbsUpRegular,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faThumbsDown as faThumbsDownSolid,
  faThumbsUp as faThumbsUpSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface ThumbsUpOrDownProps {
  onChange: (value: ThumbStatus) => void;
  className?: string;
  initialValue?: ThumbStatus;
  selectedStateDisabled?: boolean; // if this is true, thumbs cant be selected. Patient summary uses this
}

export type ThumbStatus = boolean | undefined;

export const FeedbackThumbs = ({
  onChange,
  className,
  initialValue,
  selectedStateDisabled,
}: ThumbsUpOrDownProps) => {
  const telemetry = useTelemetry();

  const handleThumbsUp = () => {
    telemetry.trackInteraction('feedback_thumbs_up');
    if (selectedStateDisabled) {
      return;
    }
    onChange(initialValue === true ? undefined : true);
  };

  const handleThumbsDown = () => {
    telemetry.trackInteraction('feedback_thumbs_down');
    if (selectedStateDisabled) {
      return;
    }
    onChange(initialValue === false ? undefined : false);
  };

  return (
    <div className={twx('flex gap-[10px]', className)}>
      <button
        className={twx(
          'flex aspect-square h-8 w-8 items-center justify-center rounded-full transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-50',
          {
            'bg-primary-main': initialValue === true,
            'border border-border-main bg-white hover:bg-background-hover': initialValue !== true,
          },
        )}
        onClick={handleThumbsUp}
        type="button"
        aria-label="Thumbs up"
        disabled={selectedStateDisabled}
        aria-disabled={selectedStateDisabled}
      >
        <FontAwesomeIcon
          icon={initialValue === true ? faThumbsUpSolid : faThumbsUpRegular}
          className={twx('h-4 w-4 text-content-icon', { 'text-white': initialValue === true })}
        />
      </button>
      <button
        className={twx(
          'flex aspect-square h-8 w-8 items-center justify-center rounded-full transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-50',
          {
            'bg-primary-main': initialValue === false,
            'border border-border-main bg-white hover:bg-background-hover': initialValue !== false,
          },
        )}
        type="button"
        aria-label="Thumbs down"
        onClick={handleThumbsDown}
        disabled={selectedStateDisabled}
        aria-disabled={selectedStateDisabled}
      >
        <FontAwesomeIcon
          icon={initialValue === false ? faThumbsDownSolid : faThumbsDownRegular}
          className={twx('h-4 w-4 text-content-icon', { 'text-white': initialValue === false })}
        />
      </button>
    </div>
  );
};
